const MORNING_STARTS = 5;
const AFTERNOON_STARTS = 12;
const EVENING_STARTS = 20;

export function greetingFor(hour: number): string {
  if (hour >= MORNING_STARTS && hour < AFTERNOON_STARTS) return "Good morning";
  if (hour >= AFTERNOON_STARTS && hour < EVENING_STARTS) return "Good afternoon";
  return "Good evening";
}

export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
